module.exports = __webpack_public_path__ + "985847619c6a2c92c7f90a3ea23e4dbe.svg";